import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CheckEmailAvailabilityFilterInput } from './inputs';
import { EmailAvailabilityResource } from './resources';

export default class Email {
    private basePath = '/api/email';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Check email availability
    checkAvailability = async (filter: CheckEmailAvailabilityFilterInput): Promise<EmailAvailabilityResource> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/availability?${query}`);

        return data;
    };
}
